<template>
  <div class="topics-wrapper">
    <center v-if="loadUser">
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>
    <div
      v-else
      class="container-fluid pl-2"
    >

      <div class="pl-1">
        <b-row class="my-progress g-4 text-white mb-4">
          <!-- Boxes -->
          <b-col
            v-if="user"
            lg="3"
            class="d-flex flex-column"
          >
            <div class="mb-2">
              <p class="section-title mb-0">
                {{ infoSectionTitle }}
              </p>
            </div>
            <b-card
              class="progress-box pt-2"
              style="height: 450px !important;"
              no-body
            >
              <div
                v-if="user.fname"
                class="mb-2"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <small class="d-block mb-25">Name: &nbsp;</small>
                  <feather-icon
                    v-b-tooltip.hover
                    icon="Edit3Icon"
                    size="18"
                    class="cursor-pointer text-white"
                    title="Edit Info"
                    @click="openEditProfileModal"
                  />
                </div>
                <h5 class="mb-0 font-weight-bold">
                  {{ user.fname }} {{ user.lname }}
                </h5>
              </div>
              <div
                v-if="user.email"
                class="d-flex align-items-center mb-2"
              >
                <div>
                  <small class="d-block mb-25">Email: &nbsp;</small>
                  <h5 class="mb-0 font-weight-bold">
                    {{ user.email }}
                  </h5>
                </div>
              </div>
              <div
                v-if="user.institution"
                class="d-flex align-items-center mb-2"
              >
                <div>
                  <small class="d-block mb-25">Institution: &nbsp;</small>
                  <h5 class="mb-0 font-weight-bold">
                    {{ user.institution.name }}
                  </h5>
                </div>
              </div>
              <div
                v-if="user.roles.length > 0 && user.roles.includes('Institution Admin')"
                class="d-flex align-items-center mb-1"
              >
                <div>
                  <small class="d-block mb-25">Enrolment Code: &nbsp;</small>
                  <h5 class="mb-0 font-weight-bold">
                    {{ user.institution.students_code }}
                  </h5>
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col lg="9">
            <p class="mb-2 section-title">
              {{ progressSectionTitle }}
            </p>
            <b-row class="mb-1">
              <b-col
                v-for="box in progressBoxes"
                :key="box.label"
                lg="6"
                md="6"
                class="mb-1"
              >
                <b-card
                  class="progress-box mb-0"
                  no-body
                >
                  <div class="d-flex align-items-center h-100">
                    <div
                      class="icon-wrapper d-flex align-items-center justify-content-center mr-2"
                    >
                      <feather-icon
                        :icon="box.icon"
                        size="30"
                      />
                    </div>
                    <div>
                      <small class="d-block">{{ box.label }}</small>
                      <h3 class="mb-0 font-weight-bold">
                        {{ box.value }}
                      </h3>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-card
              class="chart-card mb-0"
              style="height: 220px;"
              no-body
            >
              <div
                class="d-flex justify-content-between align-items-start mb-1"
              >
                <div>
                  <small>Progress</small>
                  <span class="ml-1 fw-bold">{{ totalSpent }}</span>
                </div>
                <b-avatar
                  size="34"
                  class="chart-icon"
                >
                  <feather-icon icon="BarChart2Icon" />
                </b-avatar>
              </div>

              <apexchart
                type="bar"
                height="150"
                :options="chartOptions"
                :series="chartSeries"
              />
            </b-card>
          </b-col>
        </b-row>
      </div>

      <div class="row align-item-center text-light mt-1 pl-1 pb-2">
        <div class="col-md-3 pt-1 section-title">
          <p class="mb-2 section-title">
            {{ experimentsSectionTitle }}
          </p>
        </div>
        <div class="col-md-9">
          <form
            class="search-form search-form-theme2 w-100"
            @submit.prevent
          >
            <img
              src="@/assets/images/skeleton/search.png"
              class="fas fa-search search-icon"
              alt="search"
            >
            <input
              v-model="filter.keyword"
              type="text"
              placeholder="Search in Experiments"
              name="Search"
              class="search-input"
            >
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <center v-if="loadExperiments">
              <b-spinner
                variant="primary"
                label="Spinning"
              />
            </center>
            <div v-else>

              <div v-if="myExperiments.data && myExperiments.data.length > 0">
                <div class="row">
                  <div
                    v-for="(item, index) in myExperiments.data"
                    :key="item.id || index"
                    class="col-md-3"
                  >
                    <div
                      v-if="item"
                      class="card bg-transparent"
                      @click="navigateEXP(item.id)"
                    >
                      <div class="image-wrapper">
                        <div class="img-exp">
                          <img
                            :src="item.image || (item.images && item.images.length > 0 ? item.images[0].url : '') || require('@/assets/images/skeleton/1.png')"
                            alt="image"
                            style="height: 246px; width: 100%; object-fit: cover; border-radius: 5px"
                          >
                          <img
                            src="@/assets/images/skeleton/play.png"
                            class="play-button"
                            alt="play-button"
                            @click.stop="openExperiment(item.targetPackage)"
                          >
                        </div>
                      </div>
                      <div class="py-50 pl-50">
                        <h3
                          v-if="item.name"
                          class="mb-0"
                        >
                          {{ item.name }}
                        </h3>
                        <p
                          v-if="item.category_name || (item.category && item.category.name)"
                          class="opacity-75"
                        >
                          {{ item.category_name || (item.category && item.category.name) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <b-row
                  v-if="myExperiments.meta && myExperiments.meta.total > myExperiments.meta.per_page"
                  class="mt-3 w-100 align-items-center"
                >
                  <b-col md="12" class="d-flex justify-content-center">
                    <b-pagination
                      v-model="filter.page"
                      :total-rows="myExperiments.meta.total"
                      :per-page="myExperiments.meta.per_page"
                      @change="onExperimentPageChange"
                      class="mb-0"
                    />
                  </b-col>
                </b-row>
              </div>
              <div
                v-else
                class="section-title text-center p-4"
              >
                <p>No experiments found.</p>
              </div>
            </div>

          </div>
        </div>
        <!-- <div class="col-md-1"></div> -->
      </div>
      <b-modal
        id="modal-edit-profile"
        v-model="editProfileModal"
        title=""
        hide-footer
        no-close-on-backdrop
        hide-header-close
        centered
      >
        <b-card-text>
          <b-form
            class="chat-app-form"
            @submit.prevent="submitProfile"
          >
            <validation-observer
              ref="profileForm"
              #default="{invalid}"
              class="w-100"
            >
              <p class="h5">
                First Name
              </p>
              <validation-provider
                #default="{ errors }"
                name="First Name"
                vid="fname"
                rules="required"
              >
                <b-input-group class="input-group-merge form-send-message mr-1">
                  <b-form-input
                    v-model="profileData.fname"
                    placeholder="Enter first name"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              <p class="h5 mt-2">
                Last Name
              </p>
              <validation-provider
                #default="{ errors }"
                name="Last Name"
                vid="lname"
                rules="required"
              >
                <b-input-group class="input-group-merge form-send-message mr-1">
                  <b-form-input
                    v-model="profileData.lname"
                    placeholder="Enter last name"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </validation-observer>
            <div class="float-right mt-3">
              <b-button
                variant="primary"
                class="rounded-pill px-2"
                type="submit"
              >
                Save
              </b-button>
              <b-button
                class="rounded-pill ml-50 px-1"
                @click="editProfileModal = false"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </b-card-text>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BAvatar,
  VBTooltip,
  BLink,
  BSpinner,
  BPagination,
  BModal,
  BForm,
  BFormInput,
  BInputGroup,
  BCardText,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@validations'

export default {
  name: 'Topics',
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BLink,
    BSpinner,
    BPagination,
    vSelect,
    apexchart: VueApexCharts,
    BModal,
    BForm,
    BFormInput,
    BInputGroup,
    BCardText,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    'filter.keyword': function () {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.filter.page = 1
        this.fetchMyExperiments()
      }, 400)
    },
    $route(to, from) {
      this.init()
    },
  },

  computed: {
    userID() {
      return this.$route.params.user_id || (this.userData ? this.userData.id : null)
    },
    isOtherUser() {
      const currentId = this.userData ? this.userData.id : null
      return !!this.$route.params.user_id && String(this.$route.params.user_id) !== String(currentId)
    },
    infoSectionTitle() {
      if (this.isOtherUser && this.user) {
        const fullName = `${this.user.fname || ''} ${this.user.lname || ''}`.trim()
        return fullName ? `Profile (${fullName})` : 'Profile'
      }
      return 'My Info'
    },
    progressSectionTitle() {
      return this.isOtherUser ? 'PROGRESS' : 'MY PROGRESS'
    },
    experimentsSectionTitle() {
      return this.isOtherUser ? 'EXPERIMENTS' : 'MY EXPERIMENTS'
    },
    ...mapGetters({
      myExperiments: 'users/myExperiments',
      loadExperiments: 'users/loadExperiments',
      courses: 'experiments/lookups',
      modules: 'experiments/lookups',
      stats: 'users/stats',
      user: 'users/user',
      loadUser: 'users/loadUser',
    }),

    ...mapGetters('vrCode', [
      'currentCode',
      'hasActiveCode',
      'isCodeExpired',
      'isCodeUsed',
      'timeLeftInMinutes',
      'load',
      'loadStatus',
      'error',
    ]),

    // filteredItems() {
    //   const itemsArray = Array.isArray(this.items) ? this.items : [];

    //   const list = !this.searchQuery
    //     ? itemsArray
    //     : itemsArray.filter(
    //         (item) =>
    //           item?.name
    //             ?.toLowerCase()
    //             ?.includes(this.searchQuery.toLowerCase()) ||
    //           item?.category?.name
    //             ?.toLowerCase()
    //             ?.includes(this.searchQuery.toLowerCase())
    //       );

    //   return list.slice(0, 3);
    // },

    progressBoxes() {
      const counts = (this.user && this.user.status_counts) || {}
      return [
        {
          label: 'Completed',
          value: counts.completed || 0,
          icon: 'CheckCircleIcon',
        },
        {
          label: 'Total Sessions',
          value: counts.total_sessions || 0,
          icon: 'ActivityIcon',
        },
        {
          label: 'In Progress',
          value: counts.in_progress || 0,
          icon: 'RefreshCwIcon',
        },
        {
          label: 'Total Duration',
          value: counts.duration_formatted || '00:00:00',
          icon: 'ClockIcon',
        },
      ]
    },
    totalSpent() {
      return ''
    },
    chartSeries() {
      return [
        {
          name: 'Spent',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          // data: [170, 250, 220, 240, 210, 579, 180, 290, 120, 230, 150, 200],
        },
      ]
    },
    chartOptions() {
      const data = this.chartSeries && this.chartSeries[0] && this.chartSeries[0].data
        ? this.chartSeries[0].data
        : []
      const max = data.length ? Math.max(...data) : null
      const maxIndex = max !== null ? data.indexOf(max) : -1

      return {
        chart: {
          toolbar: { show: false },
          background: 'transparent',
        },

        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 7,
          },
        },

        dataLabels: {
          enabled: true,
          offsetY: -2,
          style: {
            colors: ['#ffffff'],
            fontSize: '12px',
            fontWeight: '600',
          },
          background: { enabled: false },
        },

        colors: [
          ({ dataPointIndex }) => {
            if (dataPointIndex === maxIndex) return '#ffffff'
            return ''
          },
        ],

        xaxis: {
          categories: this.months,
          labels: {
            style: {
              colors: Array(this.months.length).fill('#23c7ec'),
              fontSize: '12px',
            },
          },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: { show: false },

        grid: {
          show: false,
        },

        tooltip: {
          theme: 'dark',
          y: {
            formatter: val => val,
          },
        },

        // annotations: {
        //   yaxis: [
        //     {
        //       y: 579,
        //       borderColor: "#23c7ec",
        //       strokeDashArray: 4,
        //       label: {
        //         text: "579",
        //         borderColor: "transparent",
        //         style: {
        //           color: "#23c7ec",
        //           background: "transparent",
        //           fontSize: "12px",
        //           fontWeight: "700",
        //         },
        //         offsetX: 8,
        //       },
        //     },
        //   ],
        // },
      }
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      editProfileModal: false,
      profileData: {
        fname: '',
        lname: '',
      },
      filter: {
        keyword: null,
        page: 1,
        per_page: 12,
      },
      searchTimeout: null,
      months: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    }
  },
  methods: {
    ...mapActions('vrCode', [
      'generate',
      'checkStatus',
      'cancel',
      'startCountdown',
      'stopCountdown',
      'clearError',
    ]),

    beforeDestroy() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
    },
    init() {
      this.$store.dispatch('users/showUser', this.userID)
      this.fetchMyExperiments(1)
      // this.$store.dispatch("experiments/list");
      this.checkInitialCodeStatus()
      // this.$store.dispatch("users/getProgressStats").then(() => {
      // });
      this.isLoading = false
    },
    fetchMyExperiments(page = 1) {
      this.filter.page = page
      this.$store.dispatch('users/myExperiments', {
        id: this.userID,
        query: {
          keyword: this.filter.keyword,
          page: this.filter.page,
          per_page: this.filter.per_page,
        },
      })
    },
    onExperimentPageChange(page) {
      this.fetchMyExperiments(page)
    },
    navigateEXP(id) {
      this.$router.push({ name: 'experiment_details', params: { id } })
    },

    async checkInitialCodeStatus() {
      try {
        await this.checkStatus()

        if (this.hasActiveCode && this.timeLeftInMinutes > 0) {
          console.log('Found valid active code, starting countdown')
          await this.startCountdown()
        } else if (this.currentCode && this.timeLeftInMinutes <= 0) {
          console.log('Found expired code, clearing...')
          this.$store.commit('vrCode/CLEAR_CODE')
        }
      } catch (error) {
        console.error('Error checking initial code status:', error)
        this.$store.commit('vrCode/CLEAR_CODE')
      }
    },

    async generateVRCode() {
      try {
        console.log('Generating VR Code...')

        await this.clearError()

        const response = await this.generate()
        console.log('Generate Response:', response)

        const isSuccess = response
          && ((response.data && response.data.success) || response.success)

        if (isSuccess && this.hasActiveCode && this.currentCode) {
          console.log('Code generated successfully:', {
            code: this.currentCode,
            timeLeft: this.timeLeftInMinutes,
            hasActive: this.hasActiveCode,
          })

          if (this.timeLeftInMinutes > 0) {
            await this.startCountdown()
          }
        } else {
          console.error('Failed to generate or display code:', {
            success: isSuccess,
            hasActiveCode: this.hasActiveCode,
            currentCode: this.currentCode,
            error: this.error,
          })
        }
      } catch (error) {
        console.error('Generation error:', error)
      }
    },

    async refreshCodeStatus() {
      try {
        console.log('Refreshing code status...')
        await this.checkStatus()

        if (this.hasActiveCode && this.timeLeftInMinutes > 0) {
          if (!this.$store.state.vrCode.countdownInterval) {
            await this.startCountdown()
          }
          this.$toast.success('Status refreshed - Code is active')
        } else {
          this.$toast.info('No active code found')
        }
      } catch (error) {
        console.error('Error checking code status:', error)
        if (error.response && error.response.status !== 404) {
          this.$toast.error('Error refreshing status')
        }
      }
    },

    async cancelVRCode() {
      try {
        console.log('Cancelling VR Code...')
        await this.cancel()
      } catch (error) {
        console.error('Cancel error:', error)
        this.$toast.error(this.error || 'Error cancelling VR code')
      }
    },

    openExperiment(id) {
      if (!id) return
      setTimeout(() => {
        window.vuplex.postMessage(`ButtonClicked_${id}`)
      }, 3)
    },

    openEditProfileModal() {
      this.profileData.fname = this.user.fname
      this.profileData.lname = this.user.lname
      this.editProfileModal = true
    },

    submitProfile() {
      this.$refs.profileForm.validate().then(success => {
        if (success) {
          this.updateProfile(this.profileData)
          this.editProfileModal = false
        }
      })
    },

    updateProfile(data) {
      this.$store.dispatch('users/updateProfile', { id: this.userID, data }).then(() => {
        this.$swal({
          icon: 'success',
          title: '<h4>Profile updated successfully</h4>',
          showConfirmButton: true,
          confirmButtonColor: '#7367f0',
          allowOutsideClick: true,
        })
        this.init()
      }).catch(err => {
        console.error(err)
        // this.$toast.error(err.response?.data?.message || 'Error updating profile');
      })
    },
  },

  mounted() {
    this.init()
  },

  beforeDestroy() {
    console.log('Component destroying, stopping countdown...')
    this.stopCountdown()
  },

  // watch: {
  //   hasActiveCode: {
  //     handler(newVal, oldVal) {
  //       console.log("hasActiveCode changed:", oldVal, "->", newVal);
  //       if (newVal && this.currentCode) {
  //         console.log("Code activated:", {
  //           code: this.currentCode,
  //           timeLeft: this.timeLeftInMinutes,
  //           expired: this.isCodeExpired,
  //           used: this.isCodeUsed,
  //         });
  //       }
  //     },
  //     immediate: true,
  //   },

  //   timeLeftInMinutes: {
  //     handler(newVal, oldVal) {
  //       console.log("Time left changed:", oldVal, "->", newVal);
  //       if (newVal <= 0 && oldVal > 0) {
  //         console.log("Time expired!");
  //         this.$toast.warning("VR Code has expired");
  //       }
  //     },
  //     immediate: true,
  //   },

  //   currentCode: {
  //     handler(newVal, oldVal) {
  //       console.log("Current code changed:", oldVal, "->", newVal);
  //     },
  //     immediate: true,
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.topics-wrapper {
  min-height: 100vh;
}

.card,
.card * {
  color: #ffffff;
  background: transparent;
}

.vr-code-card {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  overflow: hidden;
}

.vr-code-display {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 10px;
  backdrop-filter: blur(5px);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.code-text {
  font-family: Montserrat;
  font-size: 3rem;
  font-weight: bold;
  color: #00ff88;
  letter-spacing: 10px;
  margin: 0;
  text-shadow: 0 0 20px rgba(0, 255, 136, 0.5);
}

.code-info {
  .text-success {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}

.experiment-card {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.experiment-card:hover {
  transform: translateY(-4px);
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.image-wrapper img:first-child {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 40px;
  cursor: pointer;
}

.experiment-title {
  font-size: 1rem;
  font-weight: 600;
}

.experiment-category {
  opacity: 0.75;
  font-size: 1.1rem;
}
.section-title {
  font-size: 24px;
  color: #fefefe;
  opacity: 0.7;
  letter-spacing: 1px;
}
.my-progress {
  margin-top: 1rem;
}

.progress-box {
  height: 92px;
  border-radius: 14px;
  padding: 0 18px;
  display: flex;
  // align-items: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }

  small {
    font-size: 17px;
    opacity: 0.60;
  }

  h3 {
    font-size: 22px;
  }
}

.icon-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);

  svg {
    stroke: #fff;
    stroke-width: 2.2;
  }
}

.chart-card {
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  color: #fff;
  padding: 20px 20px 0px 20px;

  small {
    font-size: 16px;
    opacity: 0.7;
  }

  span {
    font-size: 24px;
  }
}

.chart-icon {
  background: rgba(255, 255, 255, 0.15);
  svg {
    color: #fff;
  }
}

.gap-2 {
  gap: 0.5rem;
}

.flex-fill {
  flex: 1;
}

.card,
.card * {
  box-shadow: unset;
  color: #fff;
}
.image-wrapper {
  border-radius: 10px;
  overflow: hidden;
}
.search-form {
  position: relative;
  width: 100%;
  background-color: transparent;
  border: 1px solid #ffffff75;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
}

.search-form-theme2 {
  position: relative;
  width: 100%;
  border-left: none;
  border-right: none;
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
  background-color: #00000040;
  border: 1px solid #ffffff75;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgb(0 0 0 / 65%);
  border-top: unset;
}

.search-form:focus-within {
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.search-form input[type="text"],
.search-form input[type="search"] {
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.search-form input::placeholder {
  color: #ffffffa8;
}

.search-form .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #bbb;
  font-size: 16px;
  cursor: pointer;
}
.img-exp {
  max-width: 100%;
  position: relative;
}
.play-button {
  position: absolute;
  cursor: pointer;
  bottom: 2%;
  right: 3%;
}
</style>
